module.exports = __webpack_public_path__ + "img/banner9.f0286390.png";